/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Hero_HeadlineInputs */

const en_marketing_hero_headline = /** @type {(inputs: Marketing_Hero_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ship the product, not the plumbing.`)
};

const es_marketing_hero_headline = /** @type {(inputs: Marketing_Hero_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanza el producto, no la fontanería.`)
};

const fr_marketing_hero_headline = /** @type {(inputs: Marketing_Hero_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livrez le produit, pas la tuyauterie.`)
};

/**
* | output |
* | --- |
* | "Ship the product, not the plumbing." |
*
* @param {Marketing_Hero_HeadlineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_hero_headline = /** @type {((inputs?: Marketing_Hero_HeadlineInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Hero_HeadlineInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_hero_headline(inputs)
	if (locale === "es") return es_marketing_hero_headline(inputs)
	return fr_marketing_hero_headline(inputs)
});